//initial redux
import { put, call, takeEvery, fork, all, take } from "redux-saga/effects";
import importservice from "../../services/import";

const initialState = {

};

/////////
//types
export const types = {
	PRINT: "screens/masterrules/overview/PRINT_MASTER",
	CLEAR: "screens/masterrules/overview/CLEAR_MASTER",
};

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.PRINT:
				return { ...state, output: state.output.concat(action.payload.msg) };
			case types.CLEAR:
				return { ...state, output: [] };
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([]);
	},
};

////////
//actions
export const actions = {

	print(msg) {
		return {
			type: types.PRINT,
			payload: { msg }
		};
	},

	clear() {
		return {
			type: types.CLEAR,
			payload: {}
		};
	},
};



// WEBPACK FOOTER //
// ./src/ui/MasterRules/redux.js